import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const GridItemStyle = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
}));

export const StyledCarouselContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isHorizontal',
})<{ isHorizontal?: boolean }>(({ theme, isHorizontal }) => ({
  display: isHorizontal ? 'flex' : 'grid',
  gridTemplateColumns: isHorizontal ? 'none' : 'repeat(3, 1fr)',
  flexDirection: isHorizontal ? 'row' : 'unset',
  gap: theme.spacing(1.5),
  overflowX: isHorizontal ? 'auto' : 'hidden',
  overflowY: isHorizontal ? 'hidden' : 'visible',
  '&::-webkit-scrollbar': { display: 'none' },
  scrollbarWidth: 'none',
  maxHeight: 'none',
  padding: theme.spacing(1),
  ...(isHorizontal && {
    width: '100%',
    alignItems: 'stretch',
  }),
}));

export const StyledGridItemWrapper = styled(GridItemStyle, {
  shouldForwardProp: (prop) => prop !== 'isHorizontal',
})<{ isHorizontal?: boolean }>(({ theme, isHorizontal }) => ({
  ...(isHorizontal && {
    flexShrink: 0,
    width: theme.spacing(13.625),
    paddingTop: '0 !important',
  }),
}));
